import { Kbd } from '../components/ui/Badge';
import { Dialog } from '../components/ui/Dialog';
import { MOD } from '../lib/platform';

export { MOD };

const GROUPS: { title: string; items: { keys: string[]; label: string }[] }[] = [
  {
    title: 'Скрізь',
    items: [
      { keys: ['Q'], label: 'Нова задача' },
      { keys: ['/'], label: 'Пошук' },
      { keys: [MOD, 'K'], label: 'Панель команд' },
      { keys: ['Esc'], label: 'Закрити картку, діалог чи меню' },
      { keys: ['?'], label: 'Ця довідка' },
    ],
  },
  {
    title: 'Переліки й дошка',
    items: [
      { keys: ['↑', '↓'], label: 'Перехід між задачами' },
      { keys: ['Enter'], label: 'Відкрити картку задачі' },
      { keys: ['Shift', 'F10'], label: 'Контекстне меню задачі' },
      { keys: ['Пробіл'], label: 'Узяти картку на дошці; стрілки — перемістити, Пробіл — поставити' },
    ],
  },
  {
    title: 'Форми',
    items: [
      { keys: [MOD, 'Enter'], label: 'Зберегти, створити, надіслати коментар' },
      { keys: ['@'], label: 'Згадати колегу в коментарі' },
    ],
  },
];

export function ShortcutsDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Dialog open={open} onClose={onClose} title="Гарячі клавіші" size="md">
      <div className="flex flex-col gap-5">
        {GROUPS.map((g) => (
          <section key={g.title}>
            <h3 className="mb-2 text-meta font-semibold text-fg-2">{g.title}</h3>
            <dl className="divide-y divide-line rounded-md border border-line">
              {g.items.map((i) => (
                <div key={i.label} className="flex items-center justify-between gap-4 px-3 py-2">
                  <dt className="text-body text-fg">{i.label}</dt>
                  <dd className="flex shrink-0 items-center gap-1">
                    {i.keys.map((k) => (
                      <Kbd key={k}>{k}</Kbd>
                    ))}
                  </dd>
                </div>
              ))}
            </dl>
          </section>
        ))}
      </div>
    </Dialog>
  );
}
